export const GOOGLE_CALENDAR_SCOPE_REQUESTED_KEY = "googleCalendarScopeRequested";
